import {bootstrapApplication} from '@angular/platform-browser';
import {RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules} from '@angular/router';
import {IonicRouteStrategy, provideIonicAngular} from '@ionic/angular/standalone';
import {routes} from './app/app.routes';
import {AppComponent} from './app/app.component';
import {Amplify} from 'aws-amplify';
import aws_exports from './aws-exports';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {provideHttpClient} from '@angular/common/http';
import {environment} from './environments/environment';



const amplifyConfig = aws_exports;
Amplify.configure(amplifyConfig);

bootstrapApplication(AppComponent, {
  providers: [
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)), provideAnimationsAsync(),
    provideHttpClient()
  ],
});

if (environment.production) {
  if (window) {
    window.console.debug = () => {};
    window.console.log = () => {};
    window.console.dir = () => {};
    window.alert = () => {};
  }
}
